/* eslint-disable no-undef */
// @ts-nocheck
var obj = {};
var waitingDialog =
  waitingDialog ||
  (function ($) {
    'use strict';

    // Creating modal dialog's DOM
    var $dialog = $(
      '<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
        '<div class="modal-dialog modal-m">' +
        '<div class="modal-content">' +
        '<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
        '<div class="modal-body">' +
        '<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
        '</div>' +
        '</div></div></div>'
    );

    return {
      /**
       * Opens our dialog
       * @param message Custom message
       * @param options Custom options:
       * 				  options.dialogSize - bootstrap postfix for dialog size, e.g. "sm", "m";
       * 				  options.progressType - bootstrap postfix for progress bar type, e.g. "success", "warning".
       */
      show: function (message, options) {
        // Assigning defaults
        if (typeof options === 'undefined') {
          options = {};
        }
        if (typeof message === 'undefined') {
          message = 'Loading';
        }
        var settings = $.extend(
          {
            dialogSize: 'm',
            progressType: '',
            onHide: null, // This callback runs after the dialog was hidden
          },
          options
        );

        // Configuring dialog
        $dialog
          .find('.modal-dialog')
          .attr('class', 'modal-dialog')
          .addClass('modal-' + settings.dialogSize);
        $dialog.find('.progress-bar').attr('class', 'progress-bar');
        $dialog.find('.progress-bar').addClass('progress-bar-striped');
        $dialog.find('.progress-bar').addClass('progress-bar-animated');
        // progress-bar-striped progress-bar-animated
        if (settings.progressType) {
          $dialog
            .find('.progress-bar')
            .addClass('progress-bar-' + settings.progressType);
        }
        $dialog.find('h3').text(message);
        // Adding callbacks
        if (typeof settings.onHide === 'function') {
          // eslint-disable-next-line no-unused-vars
          $dialog.off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
            settings.onHide.call($dialog);
          });
        }
        // Opening dialog
        $dialog.modal();
      },
      /**
       * Closes dialog
       */
      hide: function () {
        $dialog.modal('hide');
      },
    };
  })(jQuery);

obj.showDialog = function (str) {
  waitingDialog.show(str);
};

obj.hideDialog = function () {
  waitingDialog.hide();
};

obj.getCookie = function (name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
};

obj.setCookie = function (name, value, expiredays) {
  // var date = new Date();
  // date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
  // document.cookie =
  //   name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
    var today = new Date();
    today.setDate(today.getDate() + expiredays);
    document.cookie = name + '=' + escape(value) + '; path=/; expires=' + today.toGMTString() + ';'
};

obj.deleteCookie = function(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1999 00:00:10 GMT;';
}
  

obj.getYyyyMmDdToString = function (date) {
  var dd = date.getDate();
  var mm = date.getMonth() + 1; // January is 0!

  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }

  yyyy = yyyy.toString();
  mm = mm.toString();
  dd = dd.toString();

  // var m = date.getHours();
  // var s = date.getMinutes();

  // if (m < 10) {
  //   m = '0' + m;
  // }
  // if (s < 10) {
  //   s = '0' + s;
  // }
  // m = m.toString();
  // s = s.toString();

  var s1 = yyyy + mm + dd;
  return s1;
};

obj.getYyyyMmDdTimeToString = function (date) {
  var dd = date.getDate();
  var mm = date.getMonth() + 1; // January is 0!

  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }

  yyyy = yyyy.toString();
  mm = mm.toString();
  dd = dd.toString();

  var m = date.getHours();
  var s = date.getMinutes();

  if (m < 10) {
    m = '0' + m;
  }
  if (s < 10) {
    s = '0' + s;
  }
  m = m.toString();
  s = s.toString();

  var s1 = yyyy + '년' + mm + '월' + dd + '일 ' + m + ':' + s;
  return s1;
};

obj.replace_quot_newline = function (str) {
  var returnStr = str.replace(/&quot;/g, '"');
  return returnStr;
};

// new line 을 br 태그로 변환
obj.nl2br = function (str, is_xhtml) {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  var breakTag =
    is_xhtml || typeof is_xhtml === 'undefined' ? '<br/>' : '<br>';
  return (str + '').replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    '$1' + breakTag + '$2'
  );
};

obj.nl2double_br = function (str, is_xhtml) {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  var breakTag =
    is_xhtml || typeof is_xhtml === 'undefined' ? '<br/><br/>' : '<br><br>';
  return (str + '').replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    '$1' + breakTag + '$2'
  );
};

obj.goTo = function (url) {
  location.href = url;
};

obj.getUrlParams = function () {
  var params = {};
  window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (
    _str,
    key,
    value
  ) {
    params[key] = value;
  });
  return params;
};


obj.toCommaString =function( number ) { var regexp = /\B(?=(\d{3})+(?!\d))/g; return number.toString().replace( regexp, ',' ); }

//현재 날짜 출력
obj.getDateNow = function() {
  var date = new Date(); //무방함
  var year = date.getFullYear();
  var month = dateFormat(date.getMonth() + 1);
  var day = dateFormat(date.getDate());
  var hour = dateFormat(date.getHours());
  var minute = dateFormat(date.getMinutes());
  var second = dateFormat(date.getSeconds());

  return year + '-' + month + '-' + day
}

function dateFormat(time) {
  return time < 10 ? '0' + time : time;
}

////////////////////////////excel/////////////////
obj.dataToExcel =  function(data,type, name) {
  //data example-> [["header1","header2"..."header3"],["data1","data2"..."data3"],...["data11","data12"..."data13"]]
  let mime = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  let extension = ".xlsx";
  if (extension === ".xlsx") {
      var wb = new Workbook(),
          ws = createSheet(data,type);

      wb.SheetNames.push(name);
      wb.Sheets[name] = ws;
  
      var wopts = {
              bookType: 'xlsx',
              bookSST: false,
              type: 'binary'
          },
          wbout = XLSX.write(wb, wopts);

      data = string2ArrayBuffer(wbout);
  }
  saveAs(new Blob([data], {
          type: mime + ";" + "charset=utf-8"
      }),
      name + extension);
}

function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();
  this.SheetNames = [];
  this.Sheets = {};
}

function createSheet(data, type, opts) {
  var ws = {};
  var wscols;
  
  if(type =='delivery'){
    wscols = [{ //   받으시는 분	,받으시는 분 전화,	,	,	받는분 우편번호,	받는분 주소
            wch: 15 
        }, {
            wch: 15
        }, {
            wch: 8
        }, {
            wch: 8
        }, {
            wch: 15
        }, {
            wch: 60
        },];
  } else if(type =='order'){
    //"주문번호", "주문시간",  "가맹", "ceo", "품목", "수량", "메모
        wscols = [{
                wch: 7  
            }, {
                wch: 15
            }, {
                wch: 35
            }, {
                wch: 12
            }, {
                wch: 40
            }, {
                wch: 10 
            }, {
                wch: 30 
            }];
  } else if(type =='invoice'){
    //수화인명	수화인전화번호	송화인명	수화인핸드폰번호	수화인우편번호	수화인주소	수량	상품명	고객사용번호	비고	송화인우편번호	송화인주소	송화인전화번호
        wscols = [{
                wch: 9
            }, {
                wch: 9
            }, {
                wch: 9
            }, {
                wch: 16
            }, {
                wch: 12
            }, {
                wch: 65
            }, {
                wch: 6
            }, {
                wch: 40
            }, {
                wch: 6
            }, {
                wch: 6
            }, {
                wch: 6
            }, {
                wch: 40
            }, {
                wch: 16
            }
            ];
  } else if(type =='money'){
    //["사업자번호", "가맹점명",  "대표자명", "입금충전신청", "지급", "이월적립금",
     //"충전금합계", "이용권사용", "차감", "가맹점별이용정산", "환불금액", "실사용금액", "잔여적립금"])
        wscols = [{
                wch: 15  
            }, {
                wch: 25
            }, {
                wch: 15
            }, {
                wch: 15
            }, {
                wch: 15
            }, {
                wch: 15
            }, {
                wch: 15 
            }, {
                wch: 15
            }, {
                wch: 15
            }, {
                wch: 15
            }, {
                wch: 15
            }, {
                wch: 15
            }, {
                wch: 15
            }];
  }else if(type =='sp_ranking'){
    //["사업자번호", "가맹점명",  "대표자명", "입금충전신청", "지급", "이월적립금",
     //"충전금합계", "이용권사용", "차감", "가맹점별이용정산", "환불금액", "실사용금액", "잔여적립금"])
        wscols = [{
                wch: 15  
            }, {
                wch: 25
            }, {
                wch: 25
            }, {
                wch: 15
            }, {
              wch: 25
            }, {
              wch: 15
          }];
  }
  

  ws['!cols'] = wscols;
  var range = {
      s: {
          c: 10000000,
          r: 10000000
      },
      e: {
          c: 0,
          r: 0
      }
  };
  console.log(data.length);
  var changed = true;
  var orderNum = 0;
  var toggleColor =true;
  if(type == "delivery" || type == "money"){
      toggleColor = false;
  } else if(type == "order"){
    toggleColor = true;
  }
  for (var R = 0; R != data.length; ++R) {
      //
      if(orderNum == data[R][1]) {
          changed = false;
      }
      else{
          orderNum = data[R][1];
          changed = true;
          if(type == "delivery" || type == "money"|| type == "sp_ranking"  || type == "invoice"){
            toggleColor = false;
          } else if(type == "order")
            toggleColor = !toggleColor;
      }
      for (var C = 0; C != data[R].length; ++C) {
          if (range.s.r > R) range.s.r = R;
          if (range.s.c > C) range.s.c = C;
          if (range.e.r < R) range.e.r = R;
          if (range.e.c < C) range.e.c = C;
          var cell = {
              v: data[R][C],
              s: {}
          };
          if (cell.v == null) cell.v = '';
          var cell_ref = XLSX.utils.encode_cell({
              c: C,
              r: R
          });

          if (typeof cell.v === 'number') cell.t = 'n';
          else if (typeof cell.v === 'boolean') cell.t = 'b';
          else if (cell.v instanceof Date) {
              cell.t = 'n';
              cell.z = XLSX.SSF._table[14];
              cell.v = dateNum(cell.v);
          } else cell.t = 's';
          // if (R == 0) {
          //     cell.s = {
          //         fill: {
          //             fgColor: {
          //                 rgb: "FFFFF200"
          //             }
          //         }
          //     }
          // } else 
          {
              if (toggleColor) {
                  cell.s = {
                      fill: {
                          fgColor: {
                              rgb: "FFC3C3C3"
                          }
                      }
                  }
              } else {
                  cell.s = {
                      fill: {
                          fgColor: {
                              rgb: "FFFFFFFF"
                          }
                      }
                  }
              }
          }

          cell.s["border"] = {
              top: {
                  style: 'thin',
                  color: {
                      rgb: "FF000000"
                  }
              },
              bottom: {
                  style: 'thin',
                  color: {
                      rgb: "FF000000"
                  }
              },
              left: {
                  style: 'thin',
                  color: {
                      rgb: "FF000000"
                  }
              },
              right: {
                  style: 'thin',
                  color: {
                      rgb: "FF000000"
                  }
              }
          };
          cell.s["alignment"] = {
              horizontal: "center"
          };
          ws[cell_ref] = cell;
      }
  }
  if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
  return ws;
}

function string2ArrayBuffer(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

////////////////////////////end excel/////////////////
obj.srvTime = function (date) {
    let today;
    if(window.XMLHttpRequest){// code for Firefox, Mozilla, IE7, etc.
        let xmlHttpRequest = new XMLHttpRequest();
        xmlHttpRequest.open('HEAD', window.location.href.toString(), false);
        xmlHttpRequest.setRequestHeader("ContentType", "text/html");
        xmlHttpRequest.send('');

        var serverDate = xmlHttpRequest.getResponseHeader("Date");
        today = new Date(serverDate);
    }else{
        today = new Date()
    }
    return today;

};



/////부모에게 보내는 보고서
// 성과 지표 최소, 최대값 설정
const minScore = 0;
const maxScore = 100;
const wpmMin = 24;
const wpmMax = 120;
const rewardMax = 6;

obj.getNormalizedMetrics = function (scores) {
  const metrics = [
    { score: scores.pronScore, elementId: '#wordPron', label: '단어 발음', min: minScore, max: maxScore },
    { score: scores.speScore, elementId: '#wordSpell', label: '단어 쓰기', min: minScore, max: maxScore },
    { score: scores.senScore, elementId: '#senAcc', label: '문장별 정확도', min: minScore, max: maxScore },
    { score: scores.rateScore, elementId: '#paraAcc', label: '문단 읽기 정확도', min: minScore, max: maxScore },
    { score: scores.wpmScore, elementId: '#paraSpeed', label: '문단 읽기 속도', min: wpmMin, max: wpmMax, threshold: 24 },
    { score: scores.rewardScore, elementId: '#rewards', label: '리워드 달성률', min: minScore, max: rewardMax }
  ];


  // 성과 지표 처리 함수
  let normalizedData = [];
metrics.forEach(metric => {
  if (metric.score > (metric.threshold || 0)) {
    const s = normalizeScore(metric.score, metric.min, metric.max)
    metric.normalizedScore = s
    normalizedData.push(s);
  }
});
  
 return {metrics, normalizedData};
};

// 다른 점수들을 0에서 100 사이로 변환하는 함수
function normalizeScore(score, minScore, maxScore) {
  // @ts-ignore
  return parseInt(((score - minScore) / (maxScore - minScore)) * 100);
}




export default obj;
